import { PropsWithChildren } from 'react';
import {
    DesignSystemAlertSize,
    DesignSystemTypographyVariants,
} from '../../theme/design-system/types';
import { Typography } from '../Typography/Typography';
import { alertGridAreaTitle } from './constants';
import { useSlotContext } from '../../utils/useSlotContext';

const mapAlertSizeToTypographyVariants: Record<
    DesignSystemAlertSize,
    DesignSystemTypographyVariants
> = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
};

export const AlertTitle = (props: PropsWithChildren) => {
    const { size, titleGap, children } = useSlotContext(props, 'alert');

    return (
        <Typography
            fontWeight="semibold"
            sx={{
                gridArea: alertGridAreaTitle,
                ...(titleGap !== undefined && {
                    marginBottom: titleGap,
                }),
            }}
            variant={size ? mapAlertSizeToTypographyVariants[size] : 'xs'}
        >
            {children}
        </Typography>
    );
};
